export default __webpack_public_path__ + "static/image5-3b19109e9f309c8dba8c29892806937b.jpeg";